<app-textfield (change)='$event.stopPropagation()'
               (keyup)='searchChange($event)' placeholder='Search'></app-textfield>
